import { render, staticRenderFns } from "./ActinumPage.vue?vue&type=template&id=0bbf58c2"
import script from "./ActinumPage.vue?vue&type=script&lang=js"
export * from "./ActinumPage.vue?vue&type=script&lang=js"
import style0 from "./ActinumPage.vue?vue&type=style&index=0&id=0bbf58c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports